export const galleryItems = [
  {
    content: "LocknLock Brand In Store",
    imageUrl: "//www.locknlock.com/kor/image/common/about/brand/480-1.png",
    title: "Brand Experience",
  },
  {
    content: "LocknLock Business card",
    imageUrl: "//www.locknlock.com/kor/image/common/about/brand/480-2.png",
    title: "Brand Experience",
  },
  {
    content: "Package",
    imageUrl: "//www.locknlock.com/kor/image/common/about/brand/480-3.png",
    title: "Brand Experience",
  },
  {
    content: "LocknLock Brand Slogan",
    imageUrl: "//www.locknlock.com/kor/image/common/about/brand/480-4.png",
    title: "Brand Introduction",
  },
  {
    content: "LocknLock Box Tape",
    imageUrl: "//www.locknlock.com/kor/image/common/about/brand/480-5.png",
    title: "Brand Experience",
  },
  {
    content: "Layout Graphic",
    imageUrl: "//www.locknlock.com/kor/image/common/about/brand/480-6.png",
    title: "Brand Asset",
  },
  {
    content: "Outdoor Ads",
    imageUrl: "//www.locknlock.com/kor/image/common/about/brand/480-7.png",
    title: "Brand Experience",
  },
  {
    content: "Print Ads",
    imageUrl: "//www.locknlock.com/kor/image/common/about/brand/480-8.png",
    title: "Brand Experience",
  },
];
